import type { AuthErrorCode } from './types';
import type { Bi } from '../scenes/hub/hubCopy';

export const LOGIN_COPY = {
  welcome: { en: 'A new life for every bottle.', zh: '每個膠樽，\n都有新可能。' },
  intro: { en: 'Explore recycling through play.', zh: '一齊透過遊戲，認識回收。' },
  games: { en: '3 games to discover', zh: '探索 3 個互動遊戲' },
  title: { en: 'Welcome to the Coca-Cola Recycling Academy', zh: '歡迎來到可口可樂回收學院' },
  importantNotice: { en: 'Important Notice', zh: '重要告示' },
  subtitle: { en: 'Sign in with your school account.', zh: '使用學校提供的帳戶登入。' },
  email: { en: 'Email', zh: '電郵' },
  password: { en: 'Password', zh: '密碼' },
  passwordPlaceholder: { en: 'Enter your password', zh: '輸入密碼' },
  show: { en: 'Show', zh: '顯示' },
  hide: { en: 'Hide', zh: '隱藏' },
  signIn: { en: 'Sign in', zh: '登入' },
  loading: { en: 'Signing in…', zh: '登入中…' },
  note: {
    en: 'All students, teachers and administrators sign in with their Academy email and password.',
    zh: '學生、老師及管理員均使用學院帳戶的電郵及密碼登入。',
  },
  brand: { en: 'Coca-Cola Recycling Academy — Coca-Cola and Swire Coca-Cola', zh: '可口可樂回收學院 — 可口可樂及太古可口可樂' },
} as const satisfies Record<string, Bi>;

export const LOGIN_ERRORS: Record<AuthErrorCode, Bi> = {
  account_inactive: {
    en: 'This account is inactive. Ask your school administrator for help.',
    zh: '此帳戶已停用，請聯絡學校管理員。',
  },
  account_not_provisioned: {
    en: 'This account has not been added yet. Ask your school administrator to create or import it.',
    zh: '此帳戶尚未建立，請聯絡學校管理員建立或匯入帳戶。',
  },
  invalid_credentials: { en: 'The email or password is incorrect.', zh: '電郵或密碼不正確。' },
  too_many_attempts: { en: 'Too many attempts. Wait 15 minutes and try again.', zh: '嘗試次數過多，請等候 15 分鐘後再試。' },
  invalid_request: { en: 'The sign-in request was invalid. Please try again.', zh: '登入請求無效，請重試。' },
  service_unavailable: { en: 'The sign-in service is unavailable. Please try again shortly.', zh: '登入服務暫時無法使用，請稍後再試。' },
};
